"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SelectAllButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var provider_1 = require("../../../provider");
var SelectionControlButton_module_scss_1 = __importDefault(require("../SelectionControlButton.module.scss"));
var SelectAllButton = function () {
    var selectionState = (0, provider_1.useSelectionContext)().selectionState;
    var selectedOptions = Array.from(selectionState.selectionManager.selectedKeys);
    var disabledOptions = selectionState.disabledKeys
        ? Array.from(selectionState.disabledKeys)
        : [];
    var filteredOptions = Array.from(selectionState.collection.getKeys()).filter(function (key) { return !disabledOptions.includes(key); });
    return (react_1["default"].createElement("button", { type: "button", className: (0, classnames_1["default"])(SelectionControlButton_module_scss_1["default"].button, selectionState.selectionManager.isSelectAll && SelectionControlButton_module_scss_1["default"].isDisabled), "aria-disabled": selectionState.selectionManager.isSelectAll, onClick: function () {
            return !selectionState.selectionManager.isSelectAll &&
                selectionState.selectionManager.setSelectedKeys(__spreadArray(__spreadArray([], selectedOptions, true), filteredOptions, true));
        } }, "Select all"));
};
exports.SelectAllButton = SelectAllButton;
//# sourceMappingURL=SelectAllButton.js.map